import { shortenNumber } from '@cian/utils';
import { IResidentialComplexRoomsInfo } from '../../types/residentials';
import { ERoomsCount, IRooms } from './types';

const mapRoomToText: { [key: string]: string } = {
  9: 'студия',
  1: '1-комн.',
  2: '2-комн.',
  3: '3-комн.',
  4: '4-комн.',
  5: '5-комн.',
};

export function getRooms(roomsInfo: IResidentialComplexRoomsInfo[]): IRooms[] {
  return roomsInfo.reduce((acc, curr) => {
    /**
     * Пятикомнатных+ квартир очень мало. Показываем строчку только если они есть в продаже
     */
    if (!curr.roomsCount || (curr.roomsCount >= 5 && !curr.minPrice)) {
      return acc;
    }

    const minPrice = shortenNumber(curr.minPrice || 0, {
      separator: ',',
      billionPostfix: 'млрд',
      millionPostfix: 'млн',
    });
    const minPriceLabel = !curr.minPrice ? 'нет данных' : `от ${minPrice} руб.`;
    const roomsCount = mapRoomToText[curr.roomsCount];

    return [...acc, { roomsCount, minPrice: minPriceLabel }];
  }, []);
}

export function setStudioFirst(rooms: IResidentialComplexRoomsInfo[]) {
  const studioIndex = rooms.findIndex(room => room.roomsCount === ERoomsCount.Studio);

  if (studioIndex !== -1) {
    const roomsWithoutStudio = [...rooms];

    roomsWithoutStudio.splice(studioIndex, 1);

    return [rooms[studioIndex], ...roomsWithoutStudio];
  }

  return rooms;
}
